import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container-lg">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <img src="/images/knine-logo.svg" alt="kNine logo" style={{ width: '36px', height: '36px', borderRadius: 'var(--radius)' }} />
              <span>kNine.ai</span>
            </Link>
            <p className="footer-desc">
              AI-powered sourcing platform for recruiting and sales professionals across every industry.
              Unleash the power of intelligent contact discovery with Cooper and Roxi — your tireless sourcing companions.
            </p>
            <p className="footer-desc" style={{ fontSize: '0.8rem', marginBottom: '8px' }}>
              <a href="tel:4404854497" style={{ color: '#94a3b8' }}>(440) 485-4497</a>
              {' '}&bull;{' '}
              <a href="mailto:info@knine.ai" style={{ color: '#94a3b8' }}>info@knine.ai</a>
            </p>
            <p className="footer-desc" style={{ fontSize: '0.8rem', marginBottom: 0 }}>
              Cleveland, OH &bull; Raleigh, NC
            </p>
          </div>

          <div>
            <h4 className="footer-heading">Product</h4>
            <ul className="footer-links">
              <li><Link to="/">Platform</Link></li>
              <li><Link to="/pricing">Pricing</Link></li>
              <li><Link to="/integrations">Integrations</Link></li>
              <li><Link to="/comparisons">Comparisons</Link></li>
              <li><a href="https://app.knine.ai/register" target="_blank" rel="noopener noreferrer">Free Trial</a></li>
            </ul>
          </div>

          <div>
            <h4 className="footer-heading">Company</h4>
            <ul className="footer-links">
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
              <li><a href="https://app.knine.ai" target="_blank" rel="noopener noreferrer">Log In</a></li>
              <li><a href="https://app.knine.ai/register" target="_blank" rel="noopener noreferrer">Get Started</a></li>
            </ul>
          </div>

          <div>
            <h4 className="footer-heading">Legal</h4>
            <ul className="footer-links">
              <li><Link to="/terms">Terms of Service</Link></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <span>&copy; {new Date().getFullYear()} kNine.ai — Knock Knock AI. All rights reserved.</span>
          <div className="footer-bottom-links">
            <Link to="/terms">Terms</Link>
            <Link to="/privacy">Privacy</Link>
            <Link to="/contact">Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
